<template>
    <div
        class="feed-resource-overview-card-container"
        @click.stop="openFeed(feed)"
    >
        <div
            class="feed-card-container"

            :class="{'feed-card-conflict': feed.conflicts.length > 0}"
        >
            <div class="feed-card-container__header">
                <p class="feed-card-container__header__text">
                    {{feed.name}}
                </p>
                <el-tooltip
                    v-if="feed.conflicts.length > 0"
                    placement="bottom"
                    effect="dark"
                >
                    <i class="el-icon-info"></i>
                    <div slot="content">
                        Warning ! This scheduling overlap with :
                        <ul>
                            <li
                                v-for="(name, index) in feed.conflicts"
                                :key="index"
                            >
                                {{ name }}
                            </li>
                        </ul>
                    </div>
                </el-tooltip>
            </div>
            <div class="feed-status">
                <div
                    v-if="feed.status === 'RUNNING'"
                    class="broadcasting"
                >
                    <img src="/static/image/broadcasting.png">
                    <div>BROADCASTING</div>
                </div>
                <div
                    v-if="(feed.confirmed === true && feed.status === 'AVAILABLE')
                    || feed.status === 'STARTING' || feed.status === 'PREPARING'"
                    class="broadcasting"
                >
                    <div>CONFIRMED</div>
                </div>
                <div
                    v-if="!feed.confirmed"
                    class="confirmation-pending"
                >
                    <img src="/static/image/confirmation-pending-icon.svg">
                    CONFIRMATION PENDING
                </div>
            </div>
            <div class="feed-card-container__dates">
                <div class="feed-card-container__dates__times">
                    <p class="feed-card-container__dates__times__label">
                        START TIME
                    </p>
                    <p class="feed-card-container__dates__times__date">
                        {{ feedStartDate }}
                    </p>
                    <p class="feed-card-container__dates__times__utc">
                        {{ feedStartUtcTime }}
                        <span class="feed-card-container__dates__times__utc__label">UTC 0</span>
                    </p>
                    <p class="feed-card-container__dates__times__local">
                        {{ feedStartLocalTime }}
                        <span class="feed-card-container__dates__times__local__label">LOCAL TIME</span>
                    </p>
                </div>
                <div class="feed-card-container__dates__times">
                    <p class="feed-card-container__dates__times__label">
                        END TIME
                    </p>
                    <p class="feed-card-container__dates__times__date">
                        {{ feedEndDate }}
                    </p>
                    <p class="feed-card-container__dates__times__utc">
                        {{ feedEndUtcTime }}
                        <span class="feed-card-container__dates__times__utc__label">UTC 0</span>
                    </p>
                    <p class="feed-card-container__dates__times__local">
                        {{ feedEndLocalTime }}
                        <span class="feed-card-container__dates__times__local__label">LOCAL TIME</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {

    name: 'feed-card',

    props:{
        feed:{
            type: Object,
            required: true
        }
    },
    computed:{
        feedStartDate(){
            if(this.feed.confirmed){
                return moment(this.feed.confirmed_start_date).format('YYYY-MM-DD');
            }
            return moment(this.feed.start_date).format('YYYY-MM-DD');
        },
        feedEndDate(){
            if(this.feed.confirmed){
                return moment(this.feed.confirmed_end_date).format('YYYY-MM-DD');
            }
            return moment(this.feed.end_date).format('YYYY-MM-DD');
        },
        feedStartUtcTime(){
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_start_date).format('HH:mm');
            }
            return moment.utc(this.feed.start_date).format('HH:mm');
        },
        feedEndUtcTime(){
            if(this.feed.confirmed){
                return moment.utc(this.feed.confirmed_end_date).format('HH:mm');
            }
            return moment.utc(this.feed.end_date).format('HH:mm');
        },
        feedStartLocalTime(){
            if(this.feed.confirmed){
                return moment(this.feed.confirmed_start_date).format('HH:mm');
            }
            return moment(this.feed.start_date).format('HH:mm');
        },
        feedEndLocalTime(){
            if(this.feed.confirmed){
                return moment(this.feed.confirmed_end_date).format('HH:mm');
            }
            return moment(this.feed.end_date).format('HH:mm');
        },
    },

    methods:{
        openFeed(feed){
            this.$router.push({
                name: 'feeds',
                params: { feedUid: feed.uid }
            });
        },
    }
};
</script>

<style lang="scss">
.feed-card-conflict{
    border: 1px solid #f35858;
}
.feed-card-container{
    width: 30rem;
    padding: 1rem;
    font-family: 'roboto';
    border-radius: 5px;
    background-color: #212121;
    color: #BBBBBB;
    &__header{
        display: flex;
        justify-content: space-between;
        &__is_active{
            color: #BBBBBB;
        }
        &__text{
            text-transform: uppercase;
            margin-bottom: 0;
        }
    }
    .feed-status{
        font-size: 9px;
        margin: 0;
        .broadcasting{
            display:flex;
            align-items: center;
            color: #28E37C;
        }
        .confirmation-pending{
            color: #FFDC42;
        }
        img {
            margin-right: 5px;
            height: 8px;
        }
    }
    &__dates{
        display: flex;
        gap: 3rem;
        &__times{
            &__label{
                font-size: 9px;
                margin: 0;
            }
            &__date{
                font-size: 12px;
                font-weight: bold;
                margin: 0;
            }
            &__utc{
                font-size: 12px;
                font-weight: bold;
                margin: 0;
                &__label{
                    font-size: 9px;
                    font-weight: normal;
                }
            }
            &__local{
                font-size: 10px;
                font-weight: bold;
                margin: 0;
                &__label{
                    font-size: 9px;
                    font-weight: normal;
                }
            }
        }
    }
}
.feed-resource-overview-card-container{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResourcesOverview/feed-card.vue